// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconMenu = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M56 30V34C56 35.2341 55.2341 36 54 36C52.8646 36 42.864 35 32 35C21.136 35 11.1354 36 10 36C8.76593 36 8 35.2341 8 34V30C8 28.7659 8.76593 28 10 28C11.1354 28 21.136 29 32 29C42.864 29 52.8646 28 54 28C55.2341 28 56 28.7659 56 30ZM54 46C52.8646 46 42.864 47 32 47C21.136 47 11.1354 46 10 46C8.76593 46 8 46.7659 8 48V52C8 53.2341 8.76593 54 10 54C11.1354 54 21.136 53 32 53C42.864 53 52.8646 54 54 54C55.2341 54 56 53.2341 56 52V48C56 46.7659 55.2341 46 54 46ZM54 10C52.8646 10 42.864 11 32 11C21.136 11 11.1354 10 10 10C8.76593 10 8 10.7659 8 12V16C8 17.2341 8.76593 18 10 18C11.1354 18 21.136 17 32 17C42.864 17 52.8646 18 54 18C55.2341 18 56 17.2341 56 16V12C56 10.7659 55.2341 10 54 10Z" />
    </svg>
  );
};
